// HomePage — Nami marketing site v2, ported from the Claude Design project.
// Desktop ("Nami Website v2.html") renders at ≥768px; the phone edition
// ("Nami Website v2 - Mobile.html") renders below that — a runtime switch, since
// the two designs restyle the same class names for their own medium. The mobile
// column caps at 520px so it scales cleanly across all phone sizes.
// The carousel's mouse-parallax effect is intentionally omitted.
import React, { useEffect, useState } from 'react'
import { N2Hero } from './home/hero'
import { N2Features } from './home/features'
import { N2FAQ, N2Final, N2Footer, N2Nav, N2Pricing } from './home/sections'
import { N3Nav, N3Hero } from './home/mobile/hero'
import { N3Journey, N3Pricing } from './home/mobile/sections'
import { useN2Reveal } from './home/shell'
import { startHomeVisit } from './home/track'
import './home/home.css'
import './home/mobile.css'

const CTA_LABEL = 'Get started free'
const MOBILE_QUERY = '(max-width: 767px)'

function useIsMobile() {
	const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches)
	useEffect(() => {
		const mq = window.matchMedia(MOBILE_QUERY)
		const fn = () => setIsMobile(mq.matches)
		mq.addEventListener('change', fn)
		return () => mq.removeEventListener('change', fn)
	}, [])
	return isMobile
}

export default function HomePage() {
	const isMobile = useIsMobile()
	const [menuOpen, setMenuOpen] = useState(false)

	useEffect(() => startHomeVisit(), [])

	// Opt the home page out of the global `html { zoom }` rule defined in
	// src/index.css via its `html.no-zoom` escape hatch.
	useEffect(() => {
		document.documentElement.classList.add('no-zoom')
		return () => document.documentElement.classList.remove('no-zoom')
	}, [])

	// Smooth in-page anchor scrolling with an offset for the floating nav.
	// The app scrolls on <body> (html/body carry overflow-x: hidden + height: 100%
	// in index.css), so the scroll properties go on both html and body. Scoped to
	// this page's lifetime so other routes are untouched.
	useEffect(() => {
		const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		const targets = [document.documentElement, document.body]
		const prev = targets.map((el) => ({ behavior: el.style.scrollBehavior, padding: el.style.scrollPaddingTop }))
		targets.forEach((el) => {
			if (!reduce) el.style.scrollBehavior = 'smooth'
			el.style.scrollPaddingTop = isMobile ? '84px' : '92px'
		})
		return () => targets.forEach((el, i) => {
			el.style.scrollBehavior = prev[i].behavior
			el.style.scrollPaddingTop = prev[i].padding
		})
	}, [isMobile])

	useN2Reveal()

	if (isMobile) {
		return (
			<div className="n2-home n3-host">
				<div className="n3-page">
					<N3Nav cta={CTA_LABEL} open={menuOpen} setOpen={setMenuOpen} />
					<N3Hero emph="glass" ink="gradient" ambient="both" autoPlay />
					<N3Journey len={120} />
					<N3Pricing cta={CTA_LABEL} />
					<N2FAQ />
					<div id="final"><N2Final cta={CTA_LABEL} /></div>
					<N2Footer />
				</div>
			</div>
		)
	}

	return (
		<div id="top" className="n2-home">
			<N2Nav cta={CTA_LABEL} />
			<N2Hero emph="glass" ink="gradient" ambient="both" />
			<N2Features />
			<N2Pricing />
			<N2FAQ />
			<N2Final cta={CTA_LABEL} />
			<N2Footer />
		</div>
	)
}
